<template>
  <div class="item" @mouseover="handleMouseover" @mouseout="handleMouseout" @click="handleClick()" :class="{'alarmlevel3': app.alarmlevel === 3,'alarmlevel5':  app.alarmlevel === 5 && showlevel5, 'hasRelation':hasRelation, 'noRelation':noRelation}">
    <div class="title" v-show="!iframe"><div class="title-name">{{app.name}}</div></div>
    <div v-if="showSvga" :class="'svga ' + base">
      <template v-if="app.alarmlevel === 0">
        <svga :src="'./svga/'+svga+'_b.svga'" :options="options" />
      </template>
      <template v-if="app.alarmlevel === 3">
        <svga class="svga-level3" :src="'./svga/'+svga+'_y.svga'" :options="options" />
      </template>
      <template v-if="app.alarmlevel === 5">
        <svga class="svga-level0" :src="'./svga/'+svga+'_b.svga'" @parsed="parsed" :options="options" />
        <svga class="svga-level5" :src="'./svga/'+svga+'_r.svga'" :options="options" />
      </template>
    </div>
    <div v-else class="perch" :style="{'height':base.indexOf('_big') > 0 ? '160px' : '140px'}"></div>
  </div>
</template>

<script>
export default {
  name: 'modules',
  data () {
    return {
      iframe: 0, // 是否被框架引用
      showSvga: true,
      showlevel5: false
    }
  },
  props: {
    app: {
      type: Object,
      default: () => {}
    },
    base: {
      type: String,
      default: ''
    },
    svga: {
      type: String,
      default: ''
    },
    hasRelation: {
      type: Boolean,
      default: false
    },
    noRelation: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {
        return {
          loop: 0,
          fillMode: 'forwards',
          playMode: 'forwards',
          startFrame: 0,
          endFrame: 0,
          autoPlay: true
        }
      }
    }
  },
  methods: {
    parsed () {
      this.showlevel5 = true
    },
    handleMouseover () {
      // eslint-disable-next-line no-useless-escape
      const relation = this.app.relation ? this.app.relation.replaceAll('\"', '"').replaceAll('"code":', '') : '[]'
      this.$set(this.$parent, 'relationApp', {
        tagrat: this.app.code,
        relation: JSON.parse(relation)
      })
      this.$store.dispatch('app/setRelation', {
        tagrat: this.app.code,
        relation: JSON.parse(relation)
      })
    },
    handleMouseout () {
      this.$set(this.$parent, 'relationApp', {
        tagrat: '',
        relation: []
      })
      this.$store.dispatch('app/setRelation', {
        tagrat: '',
        relation: []
      })
    },
    handleClick () {
      if ((this.app.alarmlevel === 3 || this.app.alarmlevel === 5) && this.app.alarmList) {
        this.$parent.openAlarmList(this.app.alarmList, this.app.name)
      } else {
        this.$message({
          offset: 90,
          customClass: 'message',
          message: '<div class="message-text">暫無告警信息</div>',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        })
      }
    }
  },
  watch: {
    'app.alarmlevel': {
      handler (newVal, oldVal) {
        if (oldVal !== newVal) {
          this.showSvga = false
          setTimeout(() => {
            this.showSvga = true
          }, 10)
        }
      },
      deep: true
    },
    $route: {
      handler (route) {
        this.$nextTick(() => {
          if (route.query.iframe) {
            this.iframe = route.query.iframe
          }
        })
      },
      immediate: true
    }
  }
}
</script>
